import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SbCardComponent } from './sb-card.component';

const COMPONENTS = [
  SbCardComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
  ],
})
export class SbCardModule { }
